import { RouteView, PageView } from '../layouts'
export const tduck = {
    path: '/questionnaire/list',
    name: 'BaseForm',
    component: PageView,
    meta: { title: '问卷管理', icon: 'snippets', isMenuShow: true,permission:'qn'},
    children: [
        {
            path: '/questionnaire/list',
            name: 'BaseForm',
            component: () => import('../views/tduck'),
            meta: { title: '问卷列表', keepAlive: false, isMenuShow: true,permission:'qn:list' },
        },
        {
            path: '/questionnaire/template',
            name: 'BaseForm',
            // redirect: '/tduck/template/editor',
            component: () => import('../views/tduck/detail.vue'),
            meta: { title: '', keepAlive: false, isMenuShow: false, permission: 'qn:detail' },
            children: [
                {
                    path: 'editor',
                    name: 'BaseForm',
                    component: () => import('@/views/tduck/editor'),
                    meta: { title: '', keepAlive: false, isMenuShow: false, permission: 'qn:detail' },
                },
                {
                    path: 'logic',
                    name: 'BaseForm',
                    component: () => import('../views/tduck/logic'),
                    meta: { title: '', keepAlive: false, isMenuShow: false, permission: 'qn:detail' },
                },
                {
                    path: 'preview',
                    name: 'BaseForm',
                    component: () => import('../views/tduck/preview'),
                    meta: { title: '', keepAlive: false, isMenuShow: false, permission: 'qn:detail' },
                },
                {
                    path: 'publish',
                    name: 'BaseForm',
                    component: () => import('../views/tduck/publish'),
                    meta: { title: '', keepAlive: false, isMenuShow: false, permission: 'qn:detail' },
                },
                {
                    path: 'setting',
                    name: 'BaseForm',
                    component: () => import('../views/tduck/setting'),
                    meta: { title: '', keepAlive: false, isMenuShow: false, permission: 'qn:detail' },
                },
                {
                    path: 'theme',
                    name: 'BaseForm',
                    component: () => import('../views/tduck/theme'),
                    meta: { title: '', keepAlive: false, isMenuShow: false, permission: 'qn:detail' },
                },
                {
                    path: 'statistical',
                    name: 'BaseForm',
                    component: () => import('../views/tduck/statistical'),
                    meta: { title: '', keepAlive: false, isMenuShow: false, permission: 'qn:detail' },
                },
            ]
        }
    ]
}
